const Interface = {
  namespaced: true,
  state: () => ({
    overlay: {
      isActive: false,
      zIndex: 0,
    },
  }),
  mutations: {
    SET_OVERLAY_ACTIVE(state, payload) {
      state.overlay.isActive = true;
      state.overlay.zIndex = payload;
    },
    SET_OVERLAY_DEACTIVE(state) {
      state.overlay.isActive = false;
    },
  },
  actions: {
    setOverlayActive({ commit }, payload) {
      commit("SET_OVERLAY_ACTIVE", payload);
    },
    setOverlayDeactive({ commit }) {
      commit("SET_OVERLAY_DEACTIVE");
    },
  },
};

export default Interface;